export default function CustomRadio({ values, handler }) {
    const onRadioSelected = (index) => {
        handler(values[index]);
    };

    return (
        <>
            {values.map((data, index) => (
                <div className="form-check form-check-inline" key={index}>
                    <input
                        className="form-check-input"
                        type="radio"
                        id={data}
                        name="status"
                        defaultChecked={data === 'Unapproved'}
                        value={data}
                        onClick={() => onRadioSelected(index)}
                    />
                    <label className="form-check-label" htmlFor={data}>
                        {data}
                    </label>
                </div>
            ))}
        </>
    );
}
